import React from "react";

export default function UserInitials({ firstName, lastName }) {
  // Extract the first letters from firstName and lastName
  const getInitials = () => {
    const firstInitial = firstName ? firstName[0].toUpperCase() : "";
    const lastInitial = lastName ? lastName[0].toUpperCase() : "";
    return `${firstInitial}${lastInitial}`;
  };

  return (
    <div
      style={{
        minWidth: "3rem",
        minHeight: "3rem",
        borderRadius: "50%",
        backgroundColor: "black",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
      }}
    >
      {getInitials()}
    </div>
  );
}
